import script from "./RecordDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordDrawer.vue?vue&type=script&setup=true&lang=js"

import "./RecordDrawer.vue?vue&type=style&index=0&id=432e6648&lang=scss"

const __exports__ = script;

export default __exports__